import {
  contractAddress,
  mainnetContractAddress,
  bondingCurveContractAddress,
  bondingCurveOrchestratorContractAddress,
  mainnetBondingCurveContractAddress,
  mainnetBondingCurveOrchestratorContractAddress,
  nounsAuctionHouseContractAddress,
  mainnetNounsAuctionHouseContractAddress
} from "./config";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import axios from "axios";
import * as encryptUtils from './encryptDecryptUtils';
const {
  REACT_APP_PUBLIC_KEY,
  REACT_APP_PRIVATE_KEY,
  REACT_APP_GOERLI_API_URL,
  REACT_APP_ETHEREUM_API_URL,
  REACT_APP_IS_MAINNET,
} = process.env;

let web3;
let writeProvider;
if(window.ethereum == null || window.ethereum.providers == null) {
  writeProvider = window.ethereum;
} else {
  writeProvider = window.ethereum.providers.find((provider) => provider.isMetaMask);
}

console.log(REACT_APP_IS_MAINNET);
if (REACT_APP_IS_MAINNET !== "testnet") {
  if(writeProvider == null) {
    web3 = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL);
  } else {
    web3 = createAlchemyWeb3(REACT_APP_ETHEREUM_API_URL, {writeProvider: writeProvider});
  }
} else {
  if(writeProvider == null) {
    web3 = createAlchemyWeb3(REACT_APP_GOERLI_API_URL);
  } else {
    web3 = createAlchemyWeb3(REACT_APP_GOERLI_API_URL, {writeProvider: writeProvider});
  }
}

const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
let ppvContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  ppvContract = new web3.eth.Contract(contract.abi, mainnetContractAddress);
} else {
  ppvContract = new web3.eth.Contract(contract.abi, contractAddress);
}
const contract2 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
let bondingCurveContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  bondingCurveContract = new web3.eth.Contract(
    contract2.abi,
    mainnetBondingCurveContractAddress
  );
} else {
  bondingCurveContract = new web3.eth.Contract(
    contract2.abi,
    bondingCurveContractAddress
  );
}
const contract3 = require("./artifacts/contracts/NounsToken.sol/NounsToken.json");
const contract4 = require("./artifacts/contracts/NounsAuctionHouse.sol/NounsAuctionHouse.json");
let nounsAuctionHouseContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  nounsAuctionHouseContract = new web3.eth.Contract(
    contract4.abi,
    mainnetNounsAuctionHouseContractAddress
  );
} else {
  nounsAuctionHouseContract = new web3.eth.Contract(
    contract4.abi,
    nounsAuctionHouseContractAddress
  );
}

const contract5 = require("./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json");
const contract6 = require("./artifacts/contracts/BondingCurveNFTV2.sol/BondingCurveNFTV2.json");
let bondingCurveOrchestratorContract;
if (REACT_APP_IS_MAINNET !== "testnet") {
  bondingCurveOrchestratorContract = new web3.eth.Contract(
    contract5.abi,
    mainnetBondingCurveOrchestratorContractAddress
  );
} else {
  bondingCurveOrchestratorContract = new web3.eth.Contract(
    contract5.abi,
    bondingCurveOrchestratorContractAddress
  );
}

export async function getProvider() {
  if (typeof window.ethereum !== "undefined") {
    if(window.ethereum.providers == null) {
      return window.ethereum;
    }
    const provider = window.ethereum.providers.find((provider) => provider.isMetaMask);
    await provider.request({ method: 'eth_requestAccounts' });
    return provider;
  }
  return null;
}

export async function getCurrentGasPrice() {
  let data;
  if (REACT_APP_IS_MAINNET !== "testnet") {
    data = await axios.get(
      "https://api.etherscan.io/api?module=proxy&action=eth_gasPrice&apikey=IJHX7PT3EA3FU7WHRCYA5KYZDWSSVNJAAI"
    );
  } else {
    data = await axios.get(
      "https://api-goerli.etherscan.io/api?module=proxy&action=eth_gasPrice&apikey=IJHX7PT3EA3FU7WHRCYA5KYZDWSSVNJAAI"
    );
  }
  if (data != null) {
    console.log(data);
    return parseInt(data["data"]["result"], 16);
  } else {
    return null;
  }
}

async function estimateGas(transactionObj) {
  let gas;
  try {
    gas = parseInt((await web3.eth.estimateGas(transactionObj)) * 1.03);
  } catch (err) {
    console.log(err);
    gas = 10000000;
  }
  console.log(gas);
  return gas;
}

// TODO fix this to come from creator's wallet for hyperace
export async function publishPPV(tokenCID, address, authUUID) {
  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = contractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  const nonce = await web3.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  );
  const maxGasPrice = await getCurrentGasPrice();
  const transactionData = ppvContract.methods
    .publishUpcomingMintInfo(tokenCID, 1, 0, 0, 0, address, 1, 0, 0, authUUID)
    .encodeABI();
  const estimatedGas = await estimateGas({
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce: nonce,
    data: transactionData,
  });
  console.log("publish " + nonce);
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
  };

  try {
    let signedTx = await web3.eth.accounts.signTransaction(
      tx,
      REACT_APP_PRIVATE_KEY
    );
    let sendTxPromise = new Promise(function (resolve, reject) {
      web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on("confirmation", function (confNumber, receipt, latestBlockHash) {
          resolve();
        });
    });
    await sendTxPromise;
    return true;
  } catch (err) {
    return false;
  }
}

export async function publishUpcomingMintWithInfo(
  tokenCID,
  creatorShares,
  holderShares,
  impressionFee,
  creatorRoyaltyPercentage,
  creatorAddress,
  mintLimit,
  mintPrice,
  mediaType,
  authUUID
) {
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = contractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let ppvContractAsUser = new web3.eth.Contract(
    contract.abi,
    usedContractAddress,
    {
      from: creatorAddress,
    }
  );

  try {
    const estimatedGas = await ppvContractAsUser.methods
      .publishUpcomingMintInfo(
        tokenCID,
        creatorShares,
        holderShares,
        web3.utils.toWei(impressionFee),
        creatorRoyaltyPercentage,
        creatorAddress,
        mintLimit,
        web3.utils.toWei(mintPrice),
        mediaType,
        authUUID
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      ppvContractAsUser.methods
        .publishUpcomingMintInfo(
          tokenCID,
          creatorShares,
          holderShares,
          web3.utils.toWei(impressionFee),
          creatorRoyaltyPercentage,
          creatorAddress,
          mintLimit,
          web3.utils.toWei(mintPrice),
          mediaType,
          authUUID
        )
        .send({
          from: creatorAddress,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

// TODO fix this to come from creator's wallet for hyperace
export async function mintFreePPV(tokenID, publicKey) {
  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = contractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  const nonce = await web3.eth.getTransactionCount(
    REACT_APP_PUBLIC_KEY,
    "pending"
  ); //get latest nonce
  const maxGasPrice = await getCurrentGasPrice();
  const transactionData = ppvContract.methods
    .mintTokens(1, tokenID, publicKey)
    .encodeABI();

  const estimatedGas = await estimateGas({
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce: nonce,
    data: transactionData,
    value: 0,
  });
  console.log("mint " + nonce);
  //the transaction
  const tx = {
    from: REACT_APP_PUBLIC_KEY,
    to: usedContractAddress,
    nonce: nonce,
    gas: estimatedGas,
    maxPriorityFeePerGas: maxGasPrice,
    data: transactionData,
    value: 0,
    chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
  };

  console.log(tx);
  try {
    let sendTxPromise = new Promise(function (resolve, reject) {
      web3.eth.accounts
        .signTransaction(tx, REACT_APP_PRIVATE_KEY)

        .then((signedTx) => {
          web3.eth.sendSignedTransaction(
            signedTx.rawTransaction,
            function (err, hash) {
              if (!err) {
                console.log(
                  "The hash of your transaction is: ",
                  hash,
                  "\nCheck Alchemy's Mempool to view the status of your transaction!"
                );
                resolve(true);
              } else {
                console.log(
                  "Something went wrong when submitting your transaction:",
                  err
                );
                resolve(false);
              }
            }
          );
        })
        .catch((err) => {
          console.log(" Promise failed:", err);
          reject(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (err) {
    return false;
  }
}

export async function deployBondingCurveNFTV2Contract(
  publicKey
) {
  let bondingCurveNFTV2Contract = new web3.eth.Contract(contract3.abi);

  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetBondingCurveOrchestratorContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = bondingCurveOrchestratorContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let bondingCurveNFTV2ContractAsUser = new web3.eth.Contract(contract6.abi, {
    from: publicKey,
  });

  try {
    const bytecode = contract6.bytecode;
    const estimatedGas = await bondingCurveNFTV2ContractAsUser
      .deploy(
        {
          arguments: [usedContractAddress],
          data: bytecode
        }
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      bondingCurveNFTV2ContractAsUser
        .deploy(
          {
            arguments: [usedContractAddress],
            data: bytecode
          }
        )
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("receipt", function (receipt) {
          resolve(receipt.contractAddress);
        })
        .on("error", function (error, receipt) {
          resolve(null);
        });
    });
    let contractAddress = await sendTxPromise;
    return contractAddress;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function openMint(publicKey, tokenId, protocol) {
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    if (protocol === "the402") {
      usedContractAddress = mainnetContractAddress;
    } else if(protocol === "liquid") {
      usedContractAddress = mainnetBondingCurveContractAddress;
    } else {
      usedContractAddress = mainnetBondingCurveOrchestratorContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    if (protocol === "the402") {
      usedContractAddress = contractAddress;
    } else if(protocol === "liquid") {
      usedContractAddress = bondingCurveContractAddress;
    } else {
      usedContractAddress = bondingCurveOrchestratorContractAddress;
    }
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let contractAsUser;
  if (protocol === "the402") {
    contractAsUser = new web3.eth.Contract(contract.abi, usedContractAddress, {
      from: publicKey,
    });
  } else {
    contractAsUser = new web3.eth.Contract(contract2.abi, usedContractAddress, {
      from: publicKey,
    });
  }

  try {
    const estimatedGas = await contractAsUser.methods
      .setIsReadyForMint(tokenId)
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      contractAsUser.methods
        .setIsReadyForMint(tokenId)
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function publishUpcomingBondingCurveMintWithInfo(
  tokenCID,
  creatorRoyaltyPercentage,
  creatorAddress,
  mediaType,
  authUUID,
  creatorBuyFeePerThousand,
  creatorSellFeePerThousand,
  instantLiquidityTrigger,
  isNonLiquid,
  isSigmoid,
  liquidityPeriodLength,
  parameters
) {
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetBondingCurveContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = bondingCurveContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let bondingCurveContractAsUser = new web3.eth.Contract(
    contract2.abi,
    usedContractAddress,
    {
      from: creatorAddress,
    }
  );

  try {
    const estimatedGas = await bondingCurveContractAsUser.methods
      .publishUpcomingBondingCurveMint(
        tokenCID,
        creatorRoyaltyPercentage,
        creatorAddress,
        mediaType,
        authUUID,
        creatorBuyFeePerThousand,
        creatorSellFeePerThousand,
        instantLiquidityTrigger,
        isNonLiquid,
        isSigmoid,
        liquidityPeriodLength,
        parameters
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      bondingCurveContractAsUser.methods
        .publishUpcomingBondingCurveMint(
          tokenCID,
          creatorRoyaltyPercentage,
          creatorAddress,
          mediaType,
          authUUID,
          creatorBuyFeePerThousand,
          creatorSellFeePerThousand,
          instantLiquidityTrigger,
          isNonLiquid,
          isSigmoid,
          liquidityPeriodLength,
          parameters
        )
        .send({
          from: creatorAddress,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function publishUpcomingBondingCurveMintWithInfoV2(
  tokenCID,
  creatorAddress,
  mediaType,
  authUUID,
  creatorBuyFeePerThousand,
  creatorSellFeePerThousand,
  instantLiquidityTrigger,
  isNonLiquid,
  isSigmoid,
  liquidityPeriodLength,
  parameters,
  tokenContractAddress
) {
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetBondingCurveOrchestratorContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = bondingCurveOrchestratorContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }

  let bondingCurveOrchestratorContractAsUser = new web3.eth.Contract(
    contract5.abi,
    usedContractAddress,
    {
      from: creatorAddress,
    }
  );

  try {
    const estimatedGas = await bondingCurveOrchestratorContractAsUser.methods
      .publishUpcomingBondingCurveMint(
        tokenCID,
        creatorAddress,
        mediaType,
        authUUID,
        creatorBuyFeePerThousand,
        creatorSellFeePerThousand,
        instantLiquidityTrigger,
        isNonLiquid,
        isSigmoid,
        liquidityPeriodLength,
        parameters,
        tokenContractAddress
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      bondingCurveOrchestratorContractAsUser.methods
        .publishUpcomingBondingCurveMint(
          tokenCID,
          creatorAddress,
          mediaType,
          authUUID,
          creatorBuyFeePerThousand,
          creatorSellFeePerThousand,
          instantLiquidityTrigger,
          isNonLiquid,
          isSigmoid,
          liquidityPeriodLength,
          parameters,
          tokenContractAddress
        )
        .send({
          from: creatorAddress,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (hash) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(false);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    return false;
  }
}

export async function deployNounsTokenContract(
  publicKey,
  collectionName,
  collectionSymbol
) {
  let nounsTokenContract = new web3.eth.Contract(contract3.abi);

  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetNounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = nounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let nounsTokenContractAsUser = new web3.eth.Contract(contract3.abi, {
    from: publicKey,
  });

  try {
    const bytecode = contract3.bytecode;
    const estimatedGas = await nounsTokenContractAsUser
      .deploy(
        {
          arguments: [usedContractAddress, collectionName, collectionSymbol],
          data: bytecode
        }
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      nounsTokenContractAsUser
        .deploy(
          {
            arguments: [usedContractAddress, collectionName, collectionSymbol],
            data: bytecode
          }
        )
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("receipt", function (receipt) {
          resolve(receipt.contractAddress);
        })
        .on("error", function (error, receipt) {
          resolve(null);
        });
    });
    let contractAddress = await sendTxPromise;
    return contractAddress;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function uploadNounsInfoToDBAndReturnMerkleRoot(
  tokenContractAddress,
  tokenCIDs
) {
  let allCollections = await encryptUtils.getAllNounsCollectionDetails();
  let collectionId = allCollections.length;
  let data = await axios.post(
    "https://wnswa94u31.execute-api.us-west-2.amazonaws.com/dev/upload_item_to_db",
    {
      tokenContractAddress,
      tokenCIDs,
      collectionId
    }
  );
  return data["data"];
}

export async function initializeNounCollection(
  publicKey,
  tokenContractAddress,
  reservePrice,
  duration,
  creatorAddress,
  collectionSize,
  merkleRoot
) {
  const maxGasPrice = await getCurrentGasPrice();

  let usedContractAddress;
  let provider = await getProvider();
  if (REACT_APP_IS_MAINNET !== "testnet") {
    usedContractAddress = mainnetNounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }], // ETH
    });
  } else {
    usedContractAddress = nounsAuctionHouseContractAddress;
    await provider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x5" }], // Gorli
    });
  }
  let nounsAuctionHouseContractAsUser = new web3.eth.Contract(contract4.abi, usedContractAddress, {
    from: publicKey,
  });
  console.log(merkleRoot);

  try {
    const bytecode = contract3.bytecode;
    const estimatedGas = await nounsAuctionHouseContractAsUser.methods
      .initializeNewNounToken(
        tokenContractAddress,
        web3.utils.toWei(reservePrice),
        duration,
        creatorAddress,
        collectionSize,
        merkleRoot
      )
      .estimateGas();

    let sendTxPromise = new Promise(function (resolve, reject) {
      nounsAuctionHouseContractAsUser.methods
        .initializeNewNounToken(
          tokenContractAddress,
          web3.utils.toWei(reservePrice),
          duration,
          creatorAddress,
          collectionSize,
          merkleRoot
        )
        .send({
          from: publicKey,
          gas: parseInt(estimatedGas * 1.03),
          maxPriorityFeePerGas: maxGasPrice,
          chainId: REACT_APP_IS_MAINNET !== "testnet" ? 1 : 5
        })
        .on("confirmation", function (receipt) {
          resolve(true);
        })
        .on("error", function (error, receipt) {
          resolve(null);
        });
    });
    let didApprove = await sendTxPromise;
    return didApprove;
  } catch (error) {
    console.log(error);
    return false;
  }
}